import { handleActions } from 'redux-actions';
// import {} from '../actions/types';

const defaultState = {
  items: [
    {
      image: require('images/places/export_6821.jpg'),
    },
    {
      image: require('images/places/export_5171.jpg'),
    },
    {
      image: require('images/places/export_5172.jpg'),
    },
    {
      image: require('images/places/export_hash_1.jpg'),
    },
    {
      image: require('images/places/export_7068.jpg'),
    },
    {
      image: require('images/places/export_7136.jpg'),
    },
    {
      image: require('images/places/export_20151029_111156.jpg'),
    },
    {
      image: require('images/places/export_20151029_111137.jpg'),
    },
    {
      image: require('images/places/export_2923.jpg'),
    },
    {
      image: require('images/places/export_2927.jpg'),
    },
    {
      image: require('images/places/export_2929.jpg'),
    },
    {
      image: require('images/places/export_2930.jpg'),
    },
    {
      image: require('images/places/export_2965.jpg'),
    },
    {
      image: require('images/places/export_5424.jpg'),
    },
    {
      image: require('images/places/export_5426.jpg'),
    },
    {
      image: require('images/places/export_5435.jpg'),
    },
    {
      image: require('images/places/export_asita_P1220051.jpg'),
    },
    {
      image: require('images/places/export_asita_3785.jpg'),
    },
    {
      image: require('images/places/asm_57.jpg'),
    },
    {
      image: require('images/places/asm_61.jpg'),
    },
    {
      image: require('images/places/asm_69.jpg'),
    },
    {
      image: require('images/places/asm_79.jpg'),
    },
    {
      image: require('images/places/asm_74.jpg'),
    },
    {
      image: require('images/places/asm_73.jpg'),
    },
    {
      image: require('images/places/training_628.jpg'),
    },
    {
      image: require('images/places/training_634.jpg'),
    },
    {
      image: require('images/places/training_649.jpg'),
    },
    {
      image: require('images/places/training_650.jpg'),
    },
    {
      image: require('images/places/training_651.jpg'),
    },
    {
      image: require('images/places/training_653.jpg'),
    },
    {
      image: require('images/places/training_658.jpg'),
    },
    {
      image: require('images/places/training_669.jpg'),
    },
    {
      image: require('images/places/training_679.jpg'),
    },
    {
      image: require('images/places/training_690.jpg'),
    },
    {
      image: require('images/places/training_693.jpg'),
    },
    {
      image: require('images/places/training_701.jpg'),
    },
    {
      image: require('images/places/training_730.jpg'),
    },
    {
      image: require('images/places/training_739.jpg'),
    },
    {
      image: require('images/places/training_743.jpg'),
    },
    {
      image: require('images/places/training_772.jpg'),
    },
    {
      image: require('images/places/training_773.jpg'),
    },
  ],
};

const reducerMap = {};

export default handleActions(reducerMap, defaultState);



/** WEBPACK FOOTER **
 ** ./web/js/reducers/places.js
 **/